export interface NotificationSetting {
  id: string;
  /** Matches the notificationType string used by the backend when sending. */
  notificationType: string;
  displayName: string;
  category: string;
  sortOrder: number;
  isEnabled: boolean;
  /** Employee work emails picked from the list, semicolon separated. */
  recipients?: string;
  /** Hand-typed addresses (shared mailboxes, external), semicolon separated. */
  otherRecipients?: string;
  /** False when recipients come from the record itself — the UI renders those read-only. */
  areRecipientsEditable: boolean;
  /** Explains who receives this notification when recipients are not configurable. */
  autoRecipientDescription?: string;
  adGroupConfigKey?: string;
  description?: string;
  isSystemRow: boolean;
}

export interface UpdateNotificationSetting {
  isEnabled: boolean;
  recipients?: string;
  otherRecipients?: string;
  adGroupConfigKey?: string | null;
}

/** An Entra ID group an admin can route a notification to. */
export interface NotificationGroupOption {
  configKey: string;
  name: string;
  /** False when this environment has no group id set for the key. */
  isConfigured: boolean;
}

/**
 * One service group's contract-expiry recipients. Additive: a contract expiry email reaches the
 * notification's own recipients plus the heads of that contract's service group.
 */
export interface ServiceGroupRecipient {
  id: string;
  name: string;
  notificationEmails?: string;
}

/** Notification types that also route per service group. */
export const CONTRACT_NOTIFICATION_TYPES = [
  'MSARenewal',
  'SOWExpiry',
  'ProposalExpiry',
  'ScheduleExpiry'
];

/** NotificationType of the global on/off row. */
export const MASTER_SWITCH_TYPE = '__MasterSwitch';
